// import react
import React from "react";

// import motion for animation
import { motion } from "framer-motion";

// homepage css
import "../css/homepage.css";

//===================================================================================================================
const Body = () => {
  return (
    <div>
      <div className="flex justify-between p-8">
        <motion.div
          animate={{ x: [70, 0] }}
          transition={{
            delay: 0.5,
            x: { duration: 1 },
            default: { ease: "linear" },
          }}
          className="flex flex-col px-16 py-16 space-y-10 lg:w-2/4 w-full bodytext"
        >
          <h2 className="lg:text-5xl text-3xl text-left font-sans font-semibold text-white">
            Connect with your Employees
          </h2>
          <h3 className="text-left w-[75%] text-[1rem] font-sans text-white bodytext">
            With an inbuilt employee management system and employee to employer
            interactivity, join the world of quick and efficient payouts powered
            by Tron
          </h3>
        </motion.div>
        <div className="w-2/4 hidden items-end justify-end lg:flex"></div>
      </div>
    </div>
  );
};

export default Body;
